import { useContext } from 'react';

import { UserContextInterface, UserContext } from '../context/';
import { Viewer } from '../types/Viewer';

export default function useViewer(): Viewer {
  const ctx: UserContextInterface = useContext(UserContext);
  return ctx.viewer;
}
